import { render, staticRenderFns } from "./MRProductivity.vue?vue&type=template&id=8a5c119e"
import script from "./MRProductivity.vue?vue&type=script&lang=js"
export * from "./MRProductivity.vue?vue&type=script&lang=js"
import style0 from "./MRProductivity.vue?vue&type=style&index=0&id=8a5c119e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports